import React from "react";

const Footer = () => {
  return (
    <footer className="w-full bg-[#0b0f19] text-slate-300 py-6 text-center border-t border-white/10">
      <p className="text-sm tracking-wide">
        © 2024 <span className="text-orange-400 font-semibold">Power Sense Pvt Ltd</span>. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;

